import { CONTACT } from "@/data/content";
import { Logo } from "./Logo";
import { Reveal, MaskLine } from "./Reveal";
import { ContactForm } from "./ContactForm";

export const ContactDetails = ({ small = false }) => {
  const cls = small ? "text-[13px] text-white/60" : "text-[15px] text-white/80";
  const items = [
    { k: "email", label: CONTACT.email, href: `mailto:${CONTACT.email}` },
    { k: "phone", label: CONTACT.phone, href: CONTACT.phoneHref },
    { k: "whatsapp", label: "WhatsApp", href: CONTACT.whatsappHref },
    { k: "web", label: CONTACT.web, href: CONTACT.webHref },
  ];
  return (
    <ul className={`flex flex-wrap justify-center items-center gap-x-4 gap-y-2 ${cls}`}>
      {items.map((it, i) => (
        <li key={it.k} className="flex items-center gap-4">
          {i > 0 && <span className="hidden sm:block h-3 w-px bg-[#B8874A]/60" aria-hidden="true" />}
          {it.href ? (
            <a href={it.href} className="link-underline hover:text-white transition-colors" data-testid={`${small ? "footer" : "contact"}-${it.k}-link`} {...(it.k === "web" ? { target: "_blank", rel: "noreferrer" } : {})}>{it.label}</a>
          ) : (
            <span data-testid={`${small ? "footer" : "contact"}-${it.k}`}>{it.label}</span>
          )}
        </li>
      ))}
    </ul>
  );
};

export const Contact = () => (
  <section id="contact" className="relative bg-[#16302B] text-white py-24 sm:py-32 lg:py-40 overflow-hidden grain" data-testid="contact-section">
    <div className="absolute inset-0 hairline-grid pointer-events-none" />
    <div className="relative max-w-3xl mx-auto px-5 sm:px-8 text-center">
      <Reveal className="flex justify-center">
        <Logo variant="light" size={60} testId="contact-logo" />
      </Reveal>
      <h2 className="font-display mt-12 text-4xl sm:text-5xl lg:text-6xl leading-[1.1] tracking-[-0.015em]" data-testid="contact-headline">
        <MaskLine inView>Ready to move from</MaskLine>
        <MaskLine inView delay={0.12} className="italic text-[#B8874A]">chaos to clarity?</MaskLine>
      </h2>
      <Reveal as="p" className="mt-8 text-base sm:text-lg leading-relaxed text-white/75 max-w-xl mx-auto">
        Let's start with a Discovery Session — a focused conversation to understand your goals and map the right path forward.
      </Reveal>
      <Reveal className="mt-10"><ContactDetails /></Reveal>
      <Reveal className="mt-16 border-t border-white/15 pt-12">
        <ContactForm />
      </Reveal>
    </div>
  </section>
);
